import React from 'react';
import style from './style.scss'

const ToggleSwitch = (props) => {
    const {field,type="checkbox"} = props;

    return (<div className={style.toggleSwitch}>

      <label
          className={style.formField}
          htmlFor={field.elementId}
          >
          {field.label}{field.required&&<span className={style.asterisk}> *</span>}
      </label>
            <input
                autoComplete={field.name}
                className={style.fieldInput}
                id={field.elementId}
                type={type}
                value={field.value}
                placeholder={field.placeholder}
            />
            <label
                className={style.formToggle}
                htmlFor={field.elementId}
                >
            {field.label}
        </label>

    </div>)
}

export default ToggleSwitch;
